module.exports = "/cyber/_next/static/images/bgMobile-f6140773158ae5b916260cf38db93ef0.jpg";